// Local translations
export const T = {
  en_GB: {
    productDocuments: "Product Documents",
    loading: "Loading product documents...",
    noDocumentTypes: "No document types configured for this collection.",
    noProducts: "No products found in this flow instance.",
    documentsDescription:
      "Documents attached to products in this flow. Click the link icon to open.",
    product: "Product",
    open: "Open",
  },
  nb_NO: {
    productDocuments: "Produktdokumenter",
    loading: "Laster produktdokumenter...",
    noDocumentTypes: "Ingen dokumenttyper konfigurert for denne samlingen.",
    noProducts: "Ingen produkter funnet i denne flytinstansen.",
    documentsDescription:
      "Dokumenter knyttet til produkter i denne flyten. Klikk på lenkeikonet for å åpne.",
    product: "Produkt",
    open: "Åpne",
  },
} as const;
